<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span style="font-size: 15px !important">Arquivo Índice de Aproveitamento</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="getArquivoModeloIA()">Clique aqui</a>
                  para baixar o modelo para a importação.
                  <br />
                  OBS: O arquivo deve conter as seguintes colunas:
                  <b>{{ cabecalhoArquivoIa.join(', ') }}</b>
                  (exatamente nessa ordem e com esses nomes).
                  <br />
                  OBS²: O arquivo enviado precisa estar no formato
                  <b>UTF-8</b>
                  .
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-file-input
                  v-model="arquivoIaFileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv, .zip"
                  truncate-length="30"
                  :loading="arquivoIaUploading"
                  loader-height="4"
                  :success="arquivoIaId && arquivoIaFileObj ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFileIa($event)"
                  @click:clear="clearInputsArquivoIa()"
                />
              </validation-provider>
              <input type="hidden" name="validate-upload-arquivo-ia" :value="arquivoIaId" />
            </v-col>
          </v-row>
          <v-row class="mb-n5 mt-n2 mx-auto">
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv
                :delimitador.sync="arquivoIaDelimitador"
                :involucro.sync="arquivoIaInvolucro"
                :escape.sync="arquivoIaEscape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import MovimentacaoBlindadaService from '@/services/MovimentacaoBlindadaService';
  import ArquivosService from '@/services/ArquivosService';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },
    data: () => ({
      cabecalhoArquivoIa: ['ODI', 'IAS', 'IAT']
    }),
    computed: {
      arquivoIaId: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoIa.id;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            arquivoIa: { id: value }
          });
        }
      },
      arquivoIaFileObj: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoIa.fileObj;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            arquivoIa: { fileObj: value }
          });
        }
      },
      arquivoIaUploading: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoIa.uploading;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            arquivoIa: { uploading: value }
          });
        }
      },
      arquivoIaDelimitador: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoIa.delimitador;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            arquivoIa: { delimitador: value }
          });
        }
      },
      arquivoIaInvolucro: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoIa.involucro;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            arquivoIa: { involucro: value }
          });
        }
      },
      arquivoIaEscape: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoIa.escape;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', {
            arquivoIa: { escape: value }
          });
        }
      }
    },
    methods: {
      getArquivoModeloIA() {
        this.$toast.info('Processando...', '', {
          position: 'topRight',
          timeout: 1250
        });

        MovimentacaoBlindadaService.getArquivoModeloIA()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'Arquivo IA Modelo.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo do sistema', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      },

      uploadNewFileIa(arquivo) {
        if (!arquivo) {
          this.clearInputsArquivoIa();
          return true;
        }

        this.arquivoIaId = '';
        this.arquivoIaUploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile, {})
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoIaDelimitador,
              this.arquivoIaInvolucro,
              this.arquivoIaEscape,
              this.cabecalhoArquivoIa
            );
            this.arquivoIaId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', {
                position: 'topRight',
                timeout: 6000
              });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', {
                position: 'topRight'
              });
              console.error('Erro ao fazer upload: ', err);
            }

            this.arquivoIaFileObj = null;
          })
          .finally(() => (this.arquivoIaUploading = false));
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      },

      clearInputsArquivoIa() {
        this.arquivoIaId = '';
        this.arquivoIaFileObj = null;
        this.arquivoIaDelimitador = ';';
        this.arquivoIaInvolucro = '"';
        this.arquivoIaEscape = '"';

        this.$forceUpdate();
      }
    }
  };
</script>
